/** Currencies a listing price may be quoted in (av.by, kufar, abw). Append-only. */
export const LISTING_CURRENCIES = ['USD', 'EUR', 'BYN'];
/** Limits both the start / finish screens and the api schemas use. */
export const PICKER_REPORT_LIMITS = {
    /** «Несколько слов» on the finish screen, trimmed (plan rule 22). */
    minSummaryLength: 10,
    maxSummaryLength: 1000,
    minYear: 1950,
    maxMileageKm: 2_000_000,
    maxTextLength: 120,
    /**
     * AUT-447 — the generation field («B8», «XV70 рестайлинг (2020–2024)»). The
     * api always capped it at 40 while the form allowed `maxTextLength`, so a
     * 41–120 char value passed the form and failed the create. One constant now.
     */
    maxGenerationLength: 40,
    /** AUT-458 — engine displacement, cm³ (optional; a 50 cc scooter … a 10 l truck). */
    minEngineVolumeCc: 50,
    maxEngineVolumeCc: 10_000,
};
/**
 * 17 characters, no I / O / Q (ISO 3779). Typed by hand at start — there is no
 * OCR; the plate photo is only evidence.
 */
export const VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;
export const isValidVin = (vin) => VIN_PATTERN.test(vin);
//# sourceMappingURL=standalone-report.js.map